<template>
    <tab-layout>
        <template #content>
            <div class="tab-statistics__header">
                <h2 class="m-0">
                    {{ $l10n.__('Statistiques') }}
                </h2>
                <div class="tab-statistics__container-select">
                    <CompassSelect v-model="period" @update:model-value="fetchStat">
                        <CompassDropdownOption
                            v-for="(option, index) in periods"
                            :key="index"
                            :value="option.value"
                            :label="option.label"
                        />
                    </CompassSelect>
                    <CompassSelect v-model="currency" filterable @update:model-value="fetchStat">
                        <CompassDropdownOption
                            v-for="option in currencies"
                            :key="option.id"
                            :value="option.id"
                            :label="option.name"
                        />
                    </CompassSelect>
                </div>
            </div>
            <div class="prelative">
                <preloader :display="loading" class="mt-5" />
            </div>
            <div v-if="!loading" class="flex-level fw-wrap" style="align-items: baseline">
                <div
                    v-for="(card, indexCard) in cardFormatted"
                    :key="indexCard"
                    class="stat-card no-shrink well p-0"
                >
                    <component :is="card.component" :data="card" />
                </div>
            </div>
        </template>
    </tab-layout>
</template>

<script>
import StatDefaultCard from '../../statistics/StatDefaultCard.vue';
import StatSecondaryCard from '../../statistics/StatSecondaryCard.vue';
import StatListCard from '../../statistics/StatListCard.vue';
import StatisticCards from './mapping/StatisticCards';
import { mapGetters } from 'vuex';
import { dateInterval, periods } from '../../../helpers';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import SelectInput from 'vcomponents/inputs/SelectInput.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

export default {
    components: {
        StatDefaultCard,
        StatSecondaryCard,
        StatListCard,
        Preloader,
        SelectInput,
        TabLayout,
    },
    data() {
        return {
            period: 'all',
            currency: '1',
            allCards: StatisticCards,
            cardFormatted: [],
            cards: [],
            filters: {},
            loading: true,
        };
    },
    computed: {
        periods() {
            return periods;
        },
        ...mapGetters(['availableStatCards', 'linkedid', 'linkedtype', 'currencies']),
    },
    created() {
        if (localStorage.getItem(`ov_stat_${this.linkedtype}_${this.linkedid}_period`) !== null) {
            this.period = localStorage.getItem(
                `ov_stat_${this.linkedtype}_${this.linkedid}_period`,
            );
        }
        if (localStorage.getItem(`ov_stat_${this.linkedtype}_${this.linkedid}_currency`) !== null) {
            this.currency = localStorage.getItem(
                `ov_stat_${this.linkedtype}_${this.linkedid}_currency`,
            );
        } else {
            if (this.currencies.length >= 1) {
                this.currency = this.currencies[0].id;
            }
        }
        this.fetchStat();
    },
    methods: {
        fetchStat() {
            this.loading = true;
            this.buildFilters();
            this.cards = [];
            this.cardFormatted = [];
            const routeStat = this.$router.resolve({
                name: 'overview.statistics',
                params: { linkedtype: this.linkedtype, linkedid: this.linkedid },
            });
            this.$ajax.get(
                routeStat.href,
                this.filters,
                (response) => {
                    this.cards = response;
                    this.mergeValues();
                    this.saveFilters();
                    this.loading = false;
                },
                (error) => {
                    Push.error(
                        this.$l10n.__(
                            'Une erreur est survenue lors de la récupération des statistiques.',
                            false,
                        ),
                    );
                },
            );
        },
        mergeValues() {
            this.cards.map((cardValue) => {
                if (this.availableStatCards.includes(cardValue.name)) {
                    const cardLabels = this.allCards.find((card) => card.card == cardValue.name);
                    if (cardLabels) {
                        cardValue = {
                            ...cardValue,
                            ...{ title: cardLabels.title, component: cardLabels.component },
                        };
                        if (cardValue.slots && cardValue.slots.length > 0) {
                            cardValue.slots.map((slot, index) => {
                                if (cardLabels.labels[slot.name]) {
                                    const hasNumberInTitle = cardValue.slots[index].slots.find(
                                        (number) => number.type == 'nb',
                                    )?.value;
                                    cardValue.slots[index] = {
                                        ...slot,
                                        ...{
                                            label: cardLabels.labels[slot.name].title(
                                                hasNumberInTitle ? hasNumberInTitle : null,
                                            ),
                                        },
                                    };
                                    if (slot.slots && slot.slots.length > 0) {
                                        slot.slots.reverse();
                                        slot.slots.map((subSlot, indexSub) => {
                                            cardValue.slots[index].slots[indexSub] = {
                                                ...subSlot,
                                                ...{
                                                    label: cardLabels.labels[slot.name][
                                                        subSlot.type
                                                    ],
                                                },
                                            };
                                        });
                                    }
                                }
                            });
                        }
                        this.cardFormatted.push(cardValue);
                    }
                }
            });
        },
        saveFilters() {
            localStorage.setItem(`ov_stat_${this.linkedtype}_${this.linkedid}_period`, this.period);
            localStorage.setItem(
                `ov_stat_${this.linkedtype}_${this.linkedid}_currency`,
                this.currency,
            );
        },
        buildFilters() {
            const interval = dateInterval(this.period, moment());
            this.filters.datestart = interval.start;
            this.filters.dateend = interval.end;
            this.filters.cards = this.availableStatCards;
            this.filters.currency = this.currency;
        },
    },
};
</script>

<style scoped lang="scss">
.tab-statistics {
    &__header {
        margin-bottom: var(--spacing-3);
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    &__container-select {
        display: flex;
        gap: var(--spacing-3);
        align-items: flex-end;
    }
}

.stat-card {
    width: calc(50% - 16px);
    margin-bottom: 32px;

    &:nth-child(even) {
        margin-left: 16px;
    }
    &:nth-child(odd) {
        margin-right: 16px;
    }
}
</style>
